import { AnalyticsPeriod } from 'types/interfaces/admin/analytics';

// Single-date label, matching the formatDate helper used across the other dashboard charts
// (intentionally interprets the YYYY-MM-DD string the same way so X-axes line up identically).
const formatDay = (dateStr: string): string =>
  new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

// X-axis tick label: always the bucket's start date (e.g. "Nov 21"), for both daily and weekly buckets.
export const formatBucketTick = (dateStr: string): string => formatDay(dateStr);

// Tooltip label: a single date for daily buckets (7/30), a Mon–Sun range for the weekly
// buckets used in the 1-year view (e.g. "Nov 21 – Nov 27").
export const formatBucketLabel = (dateStr: string, period: AnalyticsPeriod): string => {
  if (period !== 365) return formatDay(dateStr);
  const end = new Date(dateStr);
  end.setDate(end.getDate() + 6);
  const endStr = end.toISOString().split('T')[0];
  return `${formatDay(dateStr)} – ${formatDay(endStr)}`;
};
